<template>
  <PortalWidget :widget="widget">
    <div class="m-t-10 m-b-15">
      <button
        type="button"
        class="btn btn-success btn-sm"
        @click="showConfirmation = true"
      >
        <i class="fas fa-user-slash" />
        <span v-t="'LOGIN_SECURITY_REVOKE_ALL_TOKENS'" />
      </button>
    </div>

    <v-table
      :data="logEntries"
      :current-page.sync="currentPage"
      :page-size="10"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            v-t="'LOGIN_SECURITY_LOGIN_UTC'"
            sort-key="loginUTC"
          />
          <v-th
            v-t="'LOGIN_SECURITY_LOGIN_IP'"
            sort-key="ip"
          />
          <v-th
            v-t="'LOGIN_SECURITY_LOCATION'"
            sort-key="location"
          />
          <v-th
            v-t="'LOGIN_SECURITY_USER_AGENT'"
            sort-key="userAgent"
          />
          <v-th
            v-t="'LOGIN_SECURITY_LOGIN_TYPE'"
            sort-key="loginType"
          />
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.id"
        >
          <td>
            {{ formatDate(row.loginUTC) }}
          </td>
          <td>{{ row.ip }}</td>
          <td>{{ row.location }}</td>
          <td>{{ row.userAgent }}</td>
          <td>{{ row.loginType }}</td>
        </tr>
      </tbody>
    </v-table>
    <div class="pagination-min">
      <div class="text-center p-7">
        <smart-pagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :max-page-links="10"
        />
      </div>
    </div>

    <div
      v-if="getMyLoginHistoryStatus.status === 'pending'"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'LOGIN_SECURITY_TABLE_LOADING'" />
    </div>
    <div
      v-if="tableEmpty"
      v-t="'LOGIN_SECURITY_TABLE_EMPTY'"
      class="well well-sm text-center"
    />

    <ConfirmationModal
      v-if="showConfirmation"
      :title="$t('LOGIN_SECURITY_REVOKE_ALL_TOKENS')"
      :show-confirm-button="true"
      :show-header-close-button="true"
      :show-custom-button="false"
      @close="showConfirmation = false"
      @confirm="onRevokeTokenConfirmed"
    />
  </PortalWidget>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import messages from '../locales';
import Loader from '@/core/components/Loader';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { STATUS_SUCCESS, STATUS_ERROR, getStatus } from '@/store/helpers';
import PortalWidget from '@/core/components/PortalWidget.vue';
import { utcToLocalFormat } from '@/core/filters/utcToLocalFormat';

export default {
  name: 'LoginHistory',
  components: {
    Loader,
    ConfirmationModal,
    PortalWidget
  },
  props: {
    PortalWidgetargetId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data: function () {
    return {
      widget:{title:this.$i18n.t('LOGIN_SECURITY_PAGE_TITLE'), iconClass: 'typcn typcn-user'},
      currentPage: 1,
      totalPages: 0,
      showConfirmation: false,
    };
  },
  computed: {
    ...mapState('loginSecurity', ['logEntries']),
    ...mapState('loginSecurity', {
      tableEmpty: (state) => getStatus(state, 'getMyLoginHistory').status === 'success' && state['logEntries'] && state['logEntries'].length === 0,
      getMyLoginHistoryStatus: (state) =>
        getStatus(state, 'getMyLoginHistory'),
      revokeAllTokensStatus: (state) =>  getStatus(state, 'revokeAllTokens'),
    }),
  },
  created() {
    this.getMyLoginHistory();
  },
  methods: {
    formatDate: (strDate) => utcToLocalFormat(strDate),
    ...mapActions('loginSecurity', ['getMyLoginHistory', 'revokeAllTokens']),
    async onRevokeTokenConfirmed() {
      await this.revokeAllTokens();
      if (this.revokeAllTokensStatus.status === STATUS_SUCCESS) {
        utilities.showToasterWithOptions(
          {
            type:'success', 
            body: this.$i18n.t('LOGIN_SECURITY_REVOKE_ALL_TOKENS_SUCCESS'),
            onHideCallback : function(){utilities.goToRoute({ routeName: 'login' });}
          });
        this.showConfirmation = false;
      } else if (this.revokeAllTokensStatus.status === STATUS_ERROR) {
        utilities.showToaster(
          'error',
          this.$i18n.t('LOGIN_SECURITY_REVOKE_ALL_TOKENS_FAILURE')
        );
        this.showConfirmation = false;
      }
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>